import { Axios } from '../axios'

const getDashboard = async () => {
  const { data } = await Axios.get('/hr/dashboard', {
    timeout: 30000,
  })
  return data?.data
}

const getEmployeesReport = async (payload) => {
  const { data } = await Axios.get('/employees/report/' + payload)
  return data?.data
}

const getMoneyInflow = async (payload) => {
  let start_date = payload.start_date
  let end_date = payload.end_date

  const { data } = await Axios.get(
    `/wallet/history/transaction_stat?start_date=${start_date}&end_date=${end_date}`
  )
  return data?.data
}

export const hrDashboard = {
  getDashboard,
  getEmployeesReport,
  getMoneyInflow,
}
